import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { Lock } from "lucide-react";
import { useEffect, useState } from "react";
import {
  CommonDialogFooter,
  CommonDialogHeader,
} from "@/shared/components/dialog/dialog-common";
import t from "@/lang/lang";
import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  SetImmutableRequest,
  useRltWorkOrderSetImmutableMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { useAuth } from "@/shared/lib/authorization/auth-context";
import { TextInput } from "@/shared/components/form/text-input";
import { inputValidationErrorMessages } from "@/shared/components/errors/input-error-messages";

export function SetWorkOrderImmutableDialog({
  workOrder,
}: {
  workOrder: WorkOrder;
}) {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState<SetImmutableRequest>({
    id: workOrder.id,
    userId: "",
    reason: "",
  });
  const [patch, { isLoading, error, isSuccess, reset }] =
    useRltWorkOrderSetImmutableMutation();
  const { user } = useAuth();

  useEffect(() => {
    if (isSuccess) {
      reset();
      setOpen(false);
    }
  }, [isSuccess, reset]);

  const setImmutable = () => {
    if (isLoading) return;
    patch({
      ...request,
      userId: user?.id || "",
    });
  };

  if (workOrder.immutable) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">
          <Lock className="size-5" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <CommonDialogHeader
          title={t("Arbeitsschein festschreiben?")}
          description={t(
            "Der Arbeitsschein wir festgeschrieben. Er kann danach nicht mehr geändert werden. Diese Aktion kann nicht rückgängig gemacht werden.",
          )}
        />
        <TextInput
          label={t("Grund")}
          field="reason"
          text={request.reason}
          onTextChange={(reason) => setRequest({ ...request, reason })}
          errors={inputValidationErrorMessages(error, "reason")}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={setImmutable}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
